import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const CalendarColorful = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size), ...props.style }}
    viewBox="0 0 104 104"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <title>Atom/artwork/calendar</title>
    <g
      id="On-boarding"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="how-it-works-step-1---8pt"
        transform="translate(-136.000000, -304.000000)"
      >
        <g
          id="Organism/widget/onboarding/step-1"
          transform="translate(30.000000, 184.000000)"
        >
          <g
            id="Atom/artwork/calendar"
            transform="translate(106.000000, 120.000000)"
          >
            <path
              d="M95.3312174,21.6666667 L8.66878263,21.6666667 C3.8805338,21.6666667 0,25.0179648 0,29.1534629 L0,96.5132042 C0,100.648702 3.8805338,104 8.66878263,104 L95.3312174,104 C100.119466,104 104,100.648702 104,96.5132038 L104,29.1534624 C104,25.0179648 100.119466,21.6666667 95.3312174,21.6666667 Z"
              id="Path"
              fill="#FFFFFF"
            ></path>
            <path
              d="M95.3312174,8.66666667 L8.66878263,8.66666667 C3.8805338,8.66666667 0,12.5477296 0,17.3354493 L0,39 L104,39 L104,17.3354493 C104,12.5477296 100.119466,8.66666667 95.3312174,8.66666667 Z"
              id="Path"
              fill="#1EA6D1"
            ></path>
            <path
              d="M26,30.3333333 L26,30.3333333 C23.6069336,30.3333333 21.6666667,28.3933308 21.6666667,26 L21.6666667,4.33333333 C21.6666667,1.94000257 23.6069336,0 26,0 L26,0 C28.3930664,0 30.3333333,1.94000257 30.3333333,4.33333333 L30.3333333,26 C30.3333333,28.3933308 28.3930664,30.3333333 26,30.3333333 Z"
              id="Path"
              fill="#505050"
            ></path>
            <path
              d="M78,30.3333333 L78,30.3333333 C75.6069336,30.3333333 73.6666667,28.3933308 73.6666667,26 L73.6666667,4.33333333 C73.6666667,1.94000257 75.6069336,0 78,0 L78,0 C80.3930664,0 82.3333333,1.94000257 82.3333333,4.33333333 L82.3333333,26 C82.3333333,28.3933308 80.3930664,30.3333333 78,30.3333333 Z"
              id="Path"
              fill="#505050"
            ></path>
            <g id="Group-2" transform="translate(11.700000, 62.400000)">
              <rect
                id="Rectangle"
                fill="#62CC1E"
                x="3.97193389e-13"
                y="-1.98596695e-13"
                width="20.2222222"
                height="20.2222222"
              ></rect>
              <path
                d="M16.5327835,6.29430105 L9.94379906,16.1777778 L4.40023668,12.4820695 C3.73483971,12.0391779 3.55542259,11.1406799 3.99902056,10.4759892 C4.43979311,9.81059223 5.33687829,9.63046872 6.00510083,10.0747731 L9.14136713,12.1656172 L14.1254875,4.6894366 C14.5676728,4.02403964 15.4633452,3.84391612 16.1315678,4.28822049 C16.7969645,4.73111237 16.9763816,5.62961033 16.5327835,6.29430105 Z"
                id="Path"
                fill="#FFFFFF"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
